
import { API_URL } from "./constants"

async function login(email, password) {
    try {
        const res =  await post('login', { email, password }, false)
        if(res.status !== 'success') {
            throw new Error(res.data.error)
        }
        return res
    } catch (error) {
        return { status: false, error : error}
    }
}

async function register(email, password) {
    try {
        const res = await post('users', { email, password }, false)
        if(res.status === 'fail') {
            throw new Error(res.data.error)
        }
        return login(email, password)
    } catch (error) {
        if(error === 'Email already in use') {
            return { status : false, error : error}
        }
        if ( error === 'Unable to create new user') {
            return { status : false, error : 'There was an issue creating your account. Please try again later or contact support.'}
        }
        return { status : false, error : error}
    }
}

async function createProfile(userId, firstName, lastName, githubUrl, bio) {
    return await patch(`users/${userId}`, { firstName, lastName, githubUrl, bio })
}

async function getPosts() {
    const res = await get('posts')
    return res.data.posts
}

async function post(endpoint, data, auth = true) {
    return await request('POST', endpoint, data, auth)
}

async function patch(endpoint, data, auth = true) {
    return await request('PATCH', endpoint, data, auth)
}

async function get(endpoint, auth = true) {
    return await request('GET', endpoint, null, auth)
}

async function request(method, endpoint, data, auth = true) {
    const opts = {
        headers: {
            'Content-Type': 'application/json'
        },
        method
    }

    if (method.toUpperCase() !== 'GET') {
        opts.body = JSON.stringify(data)
    }

    if (auth) {
        opts.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`
    }

    const response = await fetch(`${API_URL}/${endpoint}`, opts)

    return response.json()
}

export {
    login,
    getPosts,
    register,
    createProfile
}